module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/store_images/5_99393ad999f42d17593ca01fccd3efb8.png";